import { FlatList, StyleSheet, Text, View } from "react-native";
import React from "react";
import { ActivityIndicator, Button } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";

import { HomeScreenProps } from "../screens/HomeStack/HomeStack";
import BannerImage from "./BannerImage";

const Announcements = ({
	title,
	announcements,
	seeAllButton,
	type,
	highlight,
	loading,
}: {
	title: string;
	announcements: Array<any>;
	seeAllButton: boolean;
	type: "announcements" | "discounts";
	highlight?: boolean;
	loading?: boolean;
}) => {
	const navigation = useNavigation<HomeScreenProps["navigation"]>();

	return (
		<View>
			<View style={styles.header}>
				<Text style={[styles.title, highlight && styles.bold]}>{title}</Text>
				{seeAllButton && (
					<Button
						onPress={() => navigation.navigate("Discounts")}
						labelStyle={{ textDecorationLine: "underline" }}
					>
						Ver todos
					</Button>
				)}
			</View>
			{loading ? (
				<ActivityIndicator size={24} style={styles.loader} />
			) : (
				<FlatList
					contentContainerStyle={styles.flatListContainer}
					style={styles.flatList}
					horizontal
					data={announcements}
					ListFooterComponent={() => <View></View>}
					renderItem={({ item }) => {
						return (
							<BannerImage
								bannerImageId={
									type === "discounts" ? item.bannerImageId : item.image_id
								}
								data={item}
								type={type}
							/>
						);
					}}
				/>
			)}
		</View>
	);
};

export default Announcements;

const styles = StyleSheet.create({
	header: {
		flexDirection: "row",
		justifyContent: "space-between",
	},
	title: {
		marginLeft: "5%",
		fontSize: 16,
	},
	flatList: {
		flex: 1,
		marginTop: 14,
		marginBottom: 24,
	},
	flatListContainer: {
		paddingHorizontal: "5%",
	},
	bold: {
		fontWeight: "bold",
	},
	loader: {
		marginVertical: 10,
	},
});
